import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y1925 = new LunarYear(
  moment.tz('1925-01-24 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [30, 29, 30, 30, 29, 30, 29, 30, 30, 29, 30, 29, 30],
  4,
)

export default Y1925
